<div class="statsig-flags-dialog qe-dialog__flex">
	<h1 class="statsig-flags-dialog__heading c-heading c-heading--as-1 c-heading--color-primary"
	
	
	
	>
		Statsig Flags & Experiments
	</h1>

	<div class="qe-dialog__scroll">
		<div *ngIf="flags.length === 0" class="statsig-flags-dialog__empty">
			No experiments have been evaluated yet. Navigate through the app to populate this list.
		</div>

		<table *ngIf="flags.length > 0" class="statsig-flags-dialog__table">
			<thead>
				<tr>
					<th>Name</th>
					<th>Value</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let flag of flags">
					<td class="statsig-flags-dialog__cell-name">{{ flag.name }}</td>
					<td class="statsig-flags-dialog__cell-value">{{ flag.value }}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="statsig-flags-dialog__identity-details">
		<div class="statsig-flags-dialog__stable-id">
			<span class="statsig-flags-dialog__stable-id-label">Stable ID</span>
			<span class="statsig-flags-dialog__stable-id-value" [title]="stableId || 'Unavailable'">
				{{ stableId || 'Unavailable' }}
			</span>
			<button
				*ngIf="stableId"
				type="button"
				class="statsig-flags-dialog__stable-id-copy"
				(click)="copyStableId()"
				[attr.aria-label]="copied ? 'Stable ID copied' : 'Copy Stable ID'"
				[title]="copied ? 'Copied' : 'Copy Stable ID'"
			>
				<svg class="statsig-flags-dialog__stable-id-copy-icon" viewBox="0 0 16 16" aria-hidden="true">
					<rect x="5" y="5" width="8" height="9" rx="1" fill="none" stroke="currentColor" stroke-width="1.5" />
					<path d="M11 5V3.5A1.5 1.5 0 0 0 9.5 2h-6A1.5 1.5 0 0 0 2 3.5v6A1.5 1.5 0 0 0 3.5 11H5" fill="none" stroke="currentColor" stroke-width="1.5" />
				</svg>
			</button>
		</div>

		<div class="statsig-flags-dialog__stable-id">
			<span class="statsig-flags-dialog__stable-id-label">User ID</span>
			<span class="statsig-flags-dialog__stable-id-value" [title]="userId || 'Unavailable'">
				{{ userId || 'Unavailable' }}
			</span>
			<button
				*ngIf="userId"
				type="button"
				class="statsig-flags-dialog__stable-id-copy"
				(click)="copyUserId()"
				[attr.aria-label]="userIdCopied ? 'User ID copied' : 'Copy User ID'"
				[title]="userIdCopied ? 'Copied' : 'Copy User ID'"
			>
				<svg class="statsig-flags-dialog__stable-id-copy-icon" viewBox="0 0 16 16" aria-hidden="true">
					<rect x="5" y="5" width="8" height="9" rx="1" fill="none" stroke="currentColor" stroke-width="1.5" />
					<path d="M11 5V3.5A1.5 1.5 0 0 0 9.5 2h-6A1.5 1.5 0 0 0 2 3.5v6A1.5 1.5 0 0 0 3.5 11H5" fill="none" stroke="currentColor" stroke-width="1.5" />
				</svg>
			</button>
		</div>
	</div>

	<div class="qe-dialog__actions">
		<button
			qeBaseButton
			(click)="closeDialog()"
			class="m--primary"
		>
			OK
		</button>
	</div>
</div>
